export default __webpack_public_path__ + "static/N0188-8880281b831d9bf62ef69b28200a3e60.png";